// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--2kSfR","services":"style-module--services--8AZfY","item":"style-module--item--1krxK","shortDesc":"style-module--short-desc--198mr"};